<template>
  <el-dialog
    :visible.sync="visible"
    :width="width"
    :show-close="false"
    top="5vh"
    append-to-body
  >
    <div class="main__container">
      <img
        class="close"
        src="../datav/img/delete.png"
        alt=""
        @click.stop="handlerClose"
      />
      <div class="left-back" @click="handleBack" v-if="showBack">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
      <div>
        <!-- <ArchivesCard :detail="archivesDetail" :sn="id"></ArchivesCard> -->
        <slot></slot>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      archivesDetail: {
        archive: {
          sn: null,
        },
      },
    };
  },
  props: {
    show: Boolean,
    id: [Number, String],
    width: {
      type: String,
      default: "1200px",
    },
    showBack: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(n) {
        return this.$emit("update:show", n);
      },
    },
  },
  watch: {
    show(n, o) {
      if (!n) {
        // this.echartDispose()
      }
    },
  },
  methods: {
    handleBack() {
      this.$emit("back");
      this.visible = false;
    },
    handlerClose() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.main__container {
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
}
.wrapper1,
.wrapper2,
.wrapper3 {
  position: relative;
}
.wrapper1 {
  width: 25%;
  height: 620px;
}
.wrapper2 {
  width: 50%;
  height: 620px;
}
.wrapper3 {
  width: 50%;
}
.left-back {
  display: flex;
  align-items: center;
  position: absolute;
  left: 60px;
  top: 30px;
  z-index: 11111;
  cursor: pointer;
  color: #333;
  font-weight: bold;
  font-size: 20px;
}
.close {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 30px;
  top: 30px;
  z-index: 11111;
  cursor: pointer;
}
.bg-img {
  position: absolute;
  height: 100%;
  width: 100%;
}
.content {
  position: relative;
  z-index: 2;
  color: #fff;
  padding-top: 6%;
  padding-left: 30px;
  padding-right: 30px;
  padding-bottom: 50px;
  font-weight: bold;
  font-size: 20px;
  width: 100%;
}
.list__container {
  margin-top: 30px;
  height: 370px;
  overflow: scroll;
  .item {
    width: 100%;
    height: 39px;
    background: linear-gradient(90deg, #161f4e 0%, rgba(4, 24, 40, 0.28) 100%);
    //   opacity: 0.28;

    font-size: 16px;
    color: #01b3e6;
    font-weight: 500;
  }
  .item:hover {
    color: #fff;
    background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
  }
  .active {
    color: #fff;
    background: linear-gradient(90deg, #2a3895 0%, rgba(4, 24, 40, 0.28) 100%);
  }
}
.table-name {
  color: #abd1e7;
}
::v-deep {
  .el-dialog {
    // 取消阴影和背景色
    background: rgba(0, 0, 0, 0);

    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0);

    box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
  }
  .el-input__inner {
    height: 42px;
    border: 1px solid #077fd4;
    border-radius: 8px;
    background: none;
    color: #01b3e6;
  }
  .el-dialog__headerbtn {
    top: 78px;
    right: 100px;
    z-index: 122;
    font-size: 30px;
    color: #fff;
    font-size: bold;
  }
  .el-table,
  .el-table__body {
    background: transparent !important;
    color: #fff;
  }
  .el-table th {
    background-color: transparent !important;
  }
  .el-table tr {
    background-color: transparent !important;
  }
  .el-table__body tr.hover-row > td {
    background-color: #a5ccf2 !important;
  }
  .el-table tbody tr:hover > td {
    background-color: #17468d !important //修改成自己想要的颜色即可
;
  }
}
</style>
